var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarHeaderInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 29,
    viewBox: "0 0 44 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0634 28.1077C22.731 28.9901 21.2686 28.9901 20.9363 28.1077C19.9725 25.5454 18.3934 22.0501 16.3641 20.0207C14.3347 17.9912 10.8392 16.412 8.27749 15.4483C7.39448 15.1159 7.39448 13.6537 8.27749 13.3213C10.8392 12.3576 14.3347 10.7784 16.3641 8.74899C18.3934 6.71958 19.9725 3.2242 20.9363 0.662663C21.2686 -0.220498 22.731 -0.220498 23.0634 0.662663C24.027 3.2242 25.6062 6.71958 27.6356 8.74899C29.665 10.7784 33.1604 12.3576 35.7227 13.3213C36.6051 13.6537 36.6051 15.1159 35.7227 15.4483C33.1604 16.412 29.665 17.9912 27.6356 20.0207C25.6062 22.0501 24.027 25.5454 23.0634 28.1077Z",
    fill: "#FF6B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4525 21.9219V11.2921H23.348V21.9219H20.4525ZM21.9002 10.122C21.0276 10.122 20.3534 9.45763 20.3534 8.6247C20.3534 7.78185 21.0276 7.1274 21.9002 7.1274C22.7728 7.1274 23.4471 7.78185 23.4471 8.6247C23.4471 9.45763 22.7728 10.122 21.9002 10.122Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarHeaderInfoIcon);
export default __webpack_public_path__ + "static/media/calendar-header-info-icon.395d8f73e6702ea1a8302d72165578c8.svg";
export { ForwardRef as ReactComponent };